export default "__VITE_PUBLIC_ASSET__7d7d8014__"